import React from "react";
import PropTypes from "prop-types";

import Divider from "ui/Divider";
import LogoSection from "./Configuration/LogoSection";
import PrimaryColorSection from "./Configuration/PrimaryColorSection";
import GradientSection from "./Configuration/GradientSection";
import NameSection from "./Configuration/NameSection";

const Configuration = ({ isEdit }) => {
  return (
    <div className="theme-builder-l-configuration">
      <NameSection isEdit={isEdit} />
      <Divider />
      <LogoSection />
      <Divider />
      <PrimaryColorSection />
      <Divider />
      <GradientSection />
    </div>
  );
};

Configuration.propTypes = {
  isEdit: PropTypes.bool,
};

export default Configuration;
